import React, { FC, useState } from 'react'
import * as Styles from '../styles'
import { useKeyOnChange, useModalToggle } from '../hooks'
import { EditIcon } from 'uiKit/icons/EditIcon'
import ModalTemplate from 'uiKit/ModalTemplate'
import { SparklesIcon } from 'uiKit/icons/SparklesIcon'
import { UnkownQuestionEditElementProps, UnkownQuestionEditInnerElementProps } from './types'
import { useUnknownQuestions } from '../context'
import { UnknownQuestionUpdateAPI } from '../types'
import { TrainButtonState } from '../util/button'
import styles from './styles.module.scss'
import Select from 'react-select'
import TrainQuestionSelectorStyles from '../../../constants/trainQuestionSelectorStyles'
import { isInputEdited } from './hooks'

export const Component: FC<UnkownQuestionEditInnerElementProps> = ({ question, isOpen, toggleModal }) => {
  const { updateQuestion } = useUnknownQuestions()
  const questionsLength = question?.similarQuestions?.length + 1 || 0
  const [mainQuestion] = useState<string>(question.question)
  const [mainAnswer] = useState<string>(question.answer)

  const [currentAnswer, setCurrentAnswer] = useState<string>(question.answer)
  const [currentQuestion, setCurrentQuestion] = useState<string>(question.question)

  const [currentSelectedQuestion, setCurrentSelectedQuestion] = useState(question.question)
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState<number | null>(0)

  const allQuestions = [
    ...(question?.question ? [question.question] : []),
    ...(Array.isArray(question?.similarQuestions) ? question.similarQuestions : []),
  ].map(q => ({
    value: q,
    label: q,
  }))

  const { canBeUpdated } = isInputEdited({
    questionsLength,
    selectedQuestionIndex,
    currentAnswer,
    mainAnswer,
    currentQuestion,
    mainQuestion,
  })

  const onUpdateButtonPressed = () => {
    if (!canBeUpdated) return
    const updateBody = {
      questionBeforeUpdate: currentSelectedQuestion,
      questionForUpdate: currentQuestion,
      answer: currentAnswer,
    } as UnknownQuestionUpdateAPI

    updateQuestion(question, updateBody).then(toggleModal)
  }

  const onCurrentQuestionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentQuestion(event.target.value)
  }

  const onCurrentAnswerChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentAnswer(event.target.value)
  }

  const onSelectValueChange = (selectedOption: { value: string; label: string }) => {
    const selectedIndex = allQuestions.findIndex(q => q.value === selectedOption.value)
    setSelectedQuestionIndex(selectedIndex)
    setCurrentQuestion(selectedOption.value)
    setCurrentSelectedQuestion(selectedOption.value)
  }
  const selectedOption = mainQuestion ? allQuestions.find(option => option.value === mainQuestion) : null

  return (
    <>
      <Styles.ModalIconContainer onClick={toggleModal}>
        <EditIcon />
      </Styles.ModalIconContainer>

      <ModalTemplate
        containerClasses={styles.modal}
        open={isOpen}
        title="Add answer to the question"
        titleIcon={
          <Styles.TitleIconWrapper>
            <SparklesIcon />
          </Styles.TitleIconWrapper>
        }
        onClose={toggleModal}
        withFooter={false}>
        <Styles.ModalContainer>
          {questionsLength > 1 && (
            <Select
              styles={TrainQuestionSelectorStyles}
              options={allQuestions}
              value={selectedOption}
              onChange={onSelectValueChange}
              placeholder="Select question for training"
            />
          )}

          <Styles.SubHeader>Here you can update the question itself. You can adjust it as you need.</Styles.SubHeader>
          <Styles.AnswerInput value={currentQuestion} onChange={onCurrentQuestionChange} />

          <Styles.SubHeader>Update the answer to the question. Be imaginative and creative.</Styles.SubHeader>
          <Styles.AnswerInput value={currentAnswer} onChange={onCurrentAnswerChange} />

          <Styles.ModalButtonContainer>
            <Styles.ModalButton
              onClick={onUpdateButtonPressed}
              state={canBeUpdated ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
              Update
            </Styles.ModalButton>
          </Styles.ModalButtonContainer>
        </Styles.ModalContainer>
      </ModalTemplate>
    </>
  )
}

export const UnkownQuestionTableRowEditElement: FC<UnkownQuestionEditElementProps> = props => {
  const { isOpen, toggleModal } = useModalToggle()

  const key = useKeyOnChange(isOpen)

  return <Component key={key} {...{ isOpen, toggleModal, ...props }} />
}
